"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fmko_ts_common_1 = require("fmko-ts-common");
const LabeledInputFieldWidget_1 = tslib_1.__importDefault(require("./LabeledInputFieldWidget"));
class LabeledTextFieldWidget extends LabeledInputFieldWidget_1.default {
    constructor(args) {
        super({
            ...args,
            inputType: "text"
        });
    }
    setValue(value, fireEvents = false) {
        super.setValue(value, fireEvents);
        if (this.characterLimitElement) {
            this.updateCharacterCountText();
        }
    }
    setMaxLength(maxLength) {
        this.fieldElement.maxLength = maxLength;
        this.updateCharacterCountText();
    }
    decorateLabeledInputFieldWidgetElement(args) {
        const { maxLength } = args;
        if (maxLength) {
            this.fieldElement.maxLength = maxLength;
            this.characterLimitElement = document.createElement("small");
            this.characterLimitElement.setAttribute("role", fmko_ts_common_1.ARIARole.COMMENT);
            this.characterLimitElement.setAttribute(fmko_ts_common_1.ARIA.LIVE, "polite");
            this.updateCharacterCountText();
            this.addKeyUpListener(() => this.updateCharacterCountText());
        }
        this.decorateLabeledStringFieldWidget(args);
    }
    updateCharacterCountText() {
        const maxLength = this.fieldElement.maxLength;
        const inputLength = this.fieldElement.value.length;
        this.characterLimitElement.textContent = `${inputLength} ud af ${maxLength} tegn`;
        if (inputLength === maxLength) {
            this.characterLimitElement.setAttribute(fmko_ts_common_1.ARIA.LIVE, "assertive");
        }
        else {
            this.characterLimitElement.removeAttribute(fmko_ts_common_1.ARIA.LIVE);
        }
    }
}
exports.default = LabeledTextFieldWidget;
//# sourceMappingURL=LabeledTextFieldWidget.js.map